import React from 'react';
import { languageShort } from '../data/translations';
import { useLanguage } from '../contexts/LanguageContext';
import type { Language } from '../types/i18n';
const order: Language[] = ['fr', 'es', 'en'];
interface LanguageSwitcherProps {
  variant?: 'light' | 'dark';
}

/** FR · ES · EN inline switcher. */
export function LanguageSwitcher({
  variant = 'dark'
}: LanguageSwitcherProps) {
  const {
    language,
    setLanguage
  } = useLanguage();
  const isLight = variant === 'light';
  return <div className="flex items-center gap-1" role="group" aria-label="Language / Langue / Idioma" data-id="element-141" data-mp="4gincwxq8bif">
      {order.map((code, index) => {
      const isActive = code === language;
      return <React.Fragment key={code} data-id="element-142" data-mp="e5k08e8z6cs6" data-mpi={index}>
            {index > 0 && <span aria-hidden="true" className={isLight ? 'text-creme/30' : 'text-cacao-700/30'} data-id="element-143" data-mp="i8goakhab13i">
                ·
              </span>}
            <button type="button" onClick={() => setLanguage(code)} aria-pressed={isActive} className={`px-1.5 py-1 font-sans text-xs tracking-[0.15em] transition-colors ${isActive ? isLight ? 'text-caramel-light' : 'text-caramel' : isLight ? 'text-creme/70 hover:text-creme' : 'text-cacao-700 hover:text-caramel'}`} data-id="element-144" data-mp="2cmic3yrnqxbf">
              {languageShort[code]}
            </button>
          </React.Fragment>;
    })}
    </div>;
}